import { Box } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers-pro'
import { Dayjs } from 'dayjs'
import React from 'react'

export const DateSelect = ({
  date,
  setDate,
  label
}: {
  date: Dayjs | null
  setDate: React.Dispatch<React.SetStateAction<Dayjs | null>>
  label: string
}) => {
  return (
    <Box>
      <DatePicker
        label={label}
        value={date}
        onChange={(newValue: Dayjs | null) => setDate(newValue)}
        slotProps={{ textField: { variant: 'standard' } }}
      />
    </Box>
  )
}
